import Kfit from '../integrations/Kfit';

export const getOutlet = id => Kfit.get(`/v7/outlets/${id}`).then(res => res);
